<template>
  <div id="reporteador">
    <div
      class="separador text-center mt-5 py-5"
      data-aos="fade-up"
      data-aos-delay="600"
    >
      <p class="blockd fXG azuloscuro">Tickets Registrados</p>

      <div>
        <button class="btnaction px-5 bold" @click="logout()">
          Cerrar sesión
        </button>
      </div>
    </div>

    <div class="container-fluid">
      <!-- <div class="row pb-5">
        <div class="col-12 blockd fG azuloscuro">Semana 1</div>
      </div>-->

      <div class="row">
        <div class="col-6 py-5">
          <router-link class="btn btn-danger" to="/reportes/descarga"
            >Descarga de usuarios &raquo;
          </router-link>
        </div>
      </div>

      <b-tabs content-class="mt-3 row">
        <!-- <b-tab title="Participaciones por validar"> -->
        <b-tab title="Participaciones">
          <div class>
            <div class="col-12 azuloscuro pt-5 pb-3">
              <span class="blockd fG">Tickets</span>
              (Total: {{ tickets.length }} de {{ allTickets.length }})
            </div>

            <div class="col-12 pb-3">
              <div class="report-date-filter">
                <label>
                  <span>Fecha inicio</span>
                  <input
                    type="date"
                    v-model="dateFilterStart"
                    @change="applyDateFilter"
                  />
                </label>

                <label>
                  <span>Fecha fin</span>
                  <input
                    type="date"
                    v-model="dateFilterEnd"
                    @change="applyDateFilter"
                  />
                </label>

                <button
                  type="button"
                  class="btn btn-danger"
                  @click="setLastSevenDaysFilter"
                >
                  Últimos 7 días
                </button>
              </div>
            </div>

            <div class="col-12">
              <download-excel
                :data="this.tickets"
                :fields="this.excelcolumns"
                name="CCH Sorteo Participaciones.xls"
              >
                <button class="btn btn-danger">Exportar Tickets</button>
              </download-excel>
            </div>
            <div class="col-12">
              <v-client-table
                class="azuloscuro"
                :columns="columns"
                v-model="tickets"
                :options="options"
              >
                <a
                  slot="uri"
                  slot-scope="props"
                  target="_blank"
                  :href="props.row.uri"
                  class="glyphicon glyphicon-eye-open"
                  >Ver</a
                >

                <select
                  slot="status"
                  slot-scope="props"
                  class="form-control report-cell-select"
                  v-model="props.row.status"
                  @change="
                    changeStatusTicket(
                      props.row,
                      props.row.id,
                      props.row.user_id,
                      props.row.status,
                      props.row.email
                    )
                  "
                >
                  <option value="por validar">Por validar</option>
                  <option value="valido">Válido</option>
                  <option value="invalido">Inválido</option>
                </select>

                <select
                  slot="substatus"
                  slot-scope="props"
                  class="form-control report-cell-select"
                  v-model="props.row.substatus"
                  :disabled="props.row.status != 'invalido'"
                  @change="
                    changeSubStatusTicket(
                      props.row.id,
                      props.row.user_id,
                      props.row.substatus,
                      props.row.email
                    )
                  "
                >
                  <option value="">Sin substatus</option>
                  <option value="ticket duplicado">Ticket duplicado</option>
                  <option value="ticket ilegible">Ticket ilegible</option>
                  <option value="ticket incorrecto">Ticket incorrecto</option>
                  <option value="no es ticket">No es ticket</option>
                  <option value="fuera de vigencia">Fuera de vigencia</option>
                  <option value="no cumple monto minimo">
                    No cumple monto mínimo
                  </option>
                  <option value="otro">Otro</option>
                </select>

                <input
                  slot="cadena"
                  slot-scope="props"
                  class="form-control report-cell-input report-cell-input-wide"
                  type="text"
                  v-model.trim="props.row.cadena"
                  @focus="rememberTicketFieldValue(props.row, 'cadena')"
                  @change="updateTicketField(props.row, 'cadena')"
                />

                <input
                  slot="sucursal"
                  slot-scope="props"
                  class="form-control report-cell-input report-cell-input-wide"
                  type="text"
                  v-model.trim="props.row.sucursal"
                  @focus="rememberTicketFieldValue(props.row, 'sucursal')"
                  @change="updateTicketField(props.row, 'sucursal')"
                />

                <input
                  slot="vendedor"
                  slot-scope="props"
                  class="form-control report-cell-input report-cell-input-wide"
                  type="text"
                  v-model.trim="props.row.vendedor"
                  @focus="rememberTicketFieldValue(props.row, 'vendedor')"
                  @change="updateTicketField(props.row, 'vendedor')"
                />

                <select
                  slot="producto"
                  slot-scope="props"
                  class="form-control report-cell-select"
                  v-model="props.row.producto"
                  @focus="rememberTicketFieldValue(props.row, 'producto')"
                  @change="updateTicketField(props.row, 'producto')"
                >
                  <option value="">Sin producto</option>
                  <option value="CEMENTO GRIS">CEMENTO GRIS</option>
                  <option value="CEMENTO BLANCO">CEMENTO BLANCO</option>
                </select>

                <select
                  slot="peso"
                  slot-scope="props"
                  class="form-control report-cell-select report-cell-select-small"
                  v-model="props.row.peso"
                  @focus="rememberTicketFieldValue(props.row, 'peso')"
                  @change="updateTicketField(props.row, 'peso')"
                >
                  <option value="">Sin peso</option>
                  <option value="25KG">25KG</option>
                  <option value="50KG">50KG</option>
                </select>

                <input
                  slot="cantidad"
                  slot-scope="props"
                  class="form-control report-cell-input report-cell-input-small"
                  type="number"
                  min="0"
                  step="1"
                  v-model.number="props.row.cantidad"
                  @focus="rememberTicketFieldValue(props.row, 'cantidad')"
                  @change="updateTicketField(props.row, 'cantidad')"
                />

                <div slot="child_row" slot-scope="props" class="">
                  <div class="row pb-4">
                    <!-- <div class="col-12 px-3 pb-3 text-left">
                      <p class="bold float-left">Editar Datos del Asistente</p>
                      <router-link
                        :to="'/reportes/edicion-registro/' + props.row.id"
                        class="btn btn-danger white blanco2 d-inline-block float-left"
                      >
                        <span class="">Editar Datos</span>
                      </router-link>
                    </div> -->

                    <div class="col-12 fG"><b>Ticket</b></div>
                    <div class="col-md-6">
                      <a target="_blank" :href="props.row.ticket_img_url">
                        <img
                          :src="props.row.ticket_img_url"
                          alt="imagen ticket"
                          width="100"
                        />
                      </a>

                      <div v-if="false" class="px-3">
                        <p>Selecciona un STATUS de validación:</p>
                        <p>
                          <select
                            class="form-control"
                            name=""
                            id=""
                            v-model="props.row.status"
                            @change="seleccionaStatusChange(props.row.status)"
                          >
                            <option value="por validar" hidden>
                              Selecciona un status
                            </option>
                            <option
                              value="valido"
                              :selected="props.row.status == 'valido'"
                            >
                              Válido
                            </option>
                            <option
                              value="invalido"
                              :selected="props.row.status == 'invalido'"
                            >
                              Inválido
                            </option>
                          </select>
                        </p>

                        <p>
                          <button
                            class="btnicono"
                            @click="
                              changeStatusTicket(
                                props.row,
                                props.row.id,
                                props.row.user_id,
                                props.row.status,
                                props.row.email
                              )
                            "
                          >
                            <span class="blanco">Actualizar ticket</span>
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div v-if="false">
                    <div class="col-md-6">
                      <div class="px-3">
                        <p>Selecciona un SUBSTATUS:</p>
                        <p>
                          <select
                            class="form-control"
                            name=""
                            id=""
                            v-model="props.row.substatus"
                          >
                            <option value="por validar" hidden>
                              Selecciona un substatus
                            </option>

                            <option
                              value="ticket duplicado"
                              :selected="
                                props.row.substatus == 'ticket duplicado'
                              "
                            >
                              Ticket duplicado
                            </option>


                            <option
                              value="ticket ilegible"
                              :selected="
                                props.row.substatus == 'ticket ilegible'
                              "
                            >
                              Ticket ilegible
                            </option>
                            <option
                              value="ticket incorrecto"
                              :selected="
                                props.row.substatus == 'ticket incorrecto'
                              "
                            >
                              Ticket incorrecto
                            </option>

                            <option
                              value="no es ticket"
                              :selected="props.row.substatus == 'no es ticket'"
                            >
                              No es ticket
                            </option>

                            <option
                              value="fuera de vigencia"
                              :selected="
                                props.row.substatus == 'fuera de vigencia'
                              "
                            >
                              Fuera de vigencia
                            </option>

                            <option
                              value="no cumple monto minimo"
                              :selected="
                                props.row.substatus == 'no cumple monto minimo'
                              "
                            >
                              No cumple monto mínimo
                            </option>

                            <option
                              value="otro"
                              :selected="props.row.substatus == 'otro'"
                            >
                              otro
                            </option>
                          </select>
                        </p>

                        <p>
                          <button
                            class="btnicono"
                            @click="
                              changeSubStatusTicket(
                                props.row.id,
                                props.row.user_id,
                                props.row.substatus,
                                props.row.email
                              )
                            "
                          >
                            <span class="blanco">Actualizar ticket</span>
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row" v-if="props.row.no_membresia_plus != '' && props.row.no_membresia_plus != undefined">
                    <div class="col-12 fG"><b>Membresía plus</b></div>
                    <div class="col-md-6">
                      <a target="_blank" :href="props.row.img_membresia_frente">
                        <img
                          :src="props.row.img_membresia_frente"
                          alt="imagen membresia frente"
                          class="pr-3"
                          width="100"
                        />
                        <img
                          :src="props.row.img_membresia_reves"
                          alt="imagen membresia reves"
                          width="100"
                        />
                      </a>

                      <div class="px-3">
                        <p>¿La membresía es válida?:</p>
                        <p>
                          <select
                            class="form-control"
                            name=""
                            id=""
                            v-model="props.row.status_membresia"
                           
                          >
                            <option value="por validar" hidden>
                              Selecciona un status
                            </option>
                            <option
                              value="valida"
                              :selected="props.row.status == 'valida'"
                            >
                              Válida
                            </option>
                            <option
                              value="imagen incorrecta"
                              :selected="props.row.status == 'imagen incorrecta'"
                            >
                              Imagen incorrecta
                            </option>

                            <option
                              value="NO es membresia plus"
                              :selected="props.row.status == 'No es membresia plus'"
                            >
                              No es membresia plus
                            </option>

                            <option
                              value="numero de membresia no coincide con la foto"
                              :selected="props.row.status == 'numero de membresia no coincide con la foto'"
                            >
                              Número de membresía no coincide con la foto
                            </option>

                            <option
                              value="otro"
                              :selected="props.row.status == 'otro'"
                            >
                              Otro
                            </option>
                          </select>
                        </p>
                        
                        <p>
                          <button
                            class="btnicono"
                            @click="
                              changeStatusMembresia(
                                props.row.id,
                                props.row.user_id,
                                props.row.status_membresia,
                                props.row.email
                              )
                            "
                          >
                            <span class="blanco">Actualizar membresía</span>
                          </button>
                        </p>
                      </div>
                    </div>
                  </div> -->
                </div>

                <div
                  slot="name"
                  slot-scope="{
                    row,
                    update,
                    setEditing,
                    isEditing,
                    revertValue,
                  }"
                >
                  <span @click="setEditing(true)" v-if="!isEditing()">
                    <a>{{ row.name }}</a>
                  </span>
                  <span v-else>
                    <input type="text" v-model="row.name" />
                    <button
                      type="button"
                      class="btn btn-info btn-xs"
                      @click="
                        update(row.name);
                        setEditing(false);
                      "
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      class="btn btn-default btn-xs"
                      @click="
                        revertValue();
                        setEditing(false);
                      "
                    >
                      Cancel
                    </button>
                  </span>
                </div>
              </v-client-table>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <Footer></Footer>
    <!-- <Glyphicons></Glyphicons> -->
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 27;
import Footer from "@/components/Footer";
// import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import * as fb from "../firebase";
import * as moment from "moment";
import { ticketsCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    Footer,
    // Glyphicons,
  },
  data() {
    return {
      columns: [
        "id",
        "status",
        //"week",
        "substatus",
        "validacion",
        "validacion_fecha",
        "invoice_duplicado",
        "boleto",
        "cadena",
        "sucursal",
        "vendedor",
        "producto",
        "peso",
        "cantidad",
        //"no_membresia_plus",
        //"status_membresia",
        //"cashi",
        "created_on_server",
        //"ticket_ocr.total",
        "ticket_ocr.date",
        "nombre",
        "apellido",
        "email",
        "cadena_veryfi",
        //"monto",
        //"status_juego",
        //"mnms",
        //"time",
        //"puntos",
        // "intento_trampa",
        // "started_on",
        // "finished_on",
        // "diferencia_segundos_user",

        // "finished_on_server",
        // "diferencia_segundos_servidor",
      ],
      excelcolumns: {
        "Ticket ID": "id",
        Status: "status",
        Substatus: "substatus",
        Validacion: "validacion",
        "Validacion Fecha": "validacion_fecha",
        "Ticket Duplicado": "invoice_duplicado",
        "ID Boleto": "boleto",
        Cadena: "cadena",
        Sucursal: "sucursal",
        Vendedor: "vendedor",
        Producto: "producto",
        Peso: "peso",
        "Fecha de Registro": "created_on",
        "Fecha en Ticket": "ticket_ocr.date",
        Nombre: "nombre",
        Apellido: "apellido",
        Email: "email",
        "Cadena Veryfi": "cadena_veryfi",
        "Cantidad de bultos": "cantidad"
      },
      data: null,
      options: {
        perPage: 100,
        headings: {
          id: "Ticket UID",
          week: "Semana",
          no_membresia_plus: "No. membresía plus",
          status_membresia: "Status membresía",
          "ticket_ocr.total": "Ticket total",
          "ticket_ocr.date": "Fecha en Ticket",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          puntos_convertidos: "Puntos",
          puntos_acumulados: "Puntos agregados por ticket",
          status: "Status Ticket",
          substatus: "Substatus Ticket",
          tipo_cupon: "Tipo Cupón",
          codigo_dulceria: "Cupón Dulcería",
          codigo_oxxo: "Cupón OXXO",
          mnms: "Ticket con M&Ms",
          tiempo: "Tiempo Participación",
          segundos: "Segundos Participación",
          intento_trampa:
            "Posible Trampa (si fecha, campo válido: Segundos Servidor)",
          // started_on: "Fecha Ini User",
          // finished_on: "Fecha Fin User",
          // diferencia_segs_user: "Segundos User",
          created_on_server: "Fecha Registro (Servidor)",
          finished_on_server: "Fecha Fin de Participación (Servidor)",
          diferencia_segundos_servidor: "Segundos Servidor",
          validacion: "Validacion Veryfi",
          cantidad: "Cantidad de bultos"
        },
        editableColumns: [],
        sortable: [],
      },
      columns_users: [
        "user_id",
        "nombre",
        "apellido",
        "email",
        "genero",
        "celular",
        "fecha_nacimiento",
        "edad",
        "suma_puntos",
        "suma_time",
        "suma_time_txt",
        "num_tickets",
        "created_on",
        "dia_registro",
      ],
      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          genero: "Genero",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: ["edad", "suma_puntos", "suma_time", "num_tickets"],
      },
      tickets: [],
      allTickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      mostrar_monto: false,
      monto: 0,
      multiplicador: 1,
      boleto: "",
      editingOriginalValues: {},
      dateFilterStart: moment().subtract(6, "days").format("YYYY-MM-DD"),
      dateFilterEnd: moment().format("YYYY-MM-DD"),
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.init();
  },
  methods: {
    async init() {
      this.$store.dispatch("showLoader", true);
      this.setLastSevenDaysFilter(false);
      await this.getUsers();
      await this.getTickets();
    },
    logout() {
      this.$store.dispatch("logoutReportes");
    },
    seleccionaStatusChange(status) {
      // this.monto = 0;
      // console.log(status);
      // if(status == "$40 en productos de la Familia Coca-Cola en tiendas OXXO"){
      //   this.mostrar_monto = true;
      // }else{
      //   this.mostrar_monto = false;
      // }
    },
    setLastSevenDaysFilter(apply = true) {
      const ticketDates = this.allTickets
        .filter((ticket) => ticket.created_on_server_filter)
        .map((ticket) => moment(ticket.created_on_server_filter, "YYYY-MM-DD"));
      const endDate =
        ticketDates.length > 0 ? moment.max(ticketDates) : moment();

      this.dateFilterStart = endDate
        .clone()
        .subtract(6, "days")
        .format("YYYY-MM-DD");
      this.dateFilterEnd = endDate.format("YYYY-MM-DD");

      if (apply) {
        this.applyDateFilter();
      }
    },
    applyDateFilter() {
      const start = this.dateFilterStart
        ? moment(this.dateFilterStart, "YYYY-MM-DD").startOf("day")
        : null;
      const end = this.dateFilterEnd
        ? moment(this.dateFilterEnd, "YYYY-MM-DD").endOf("day")
        : null;

      this.tickets = this.allTickets.filter((ticket) => {
        if (!ticket.created_on_server_filter) {
          return false;
        }

        const ticketDate = moment(
          ticket.created_on_server_filter,
          "YYYY-MM-DD"
        );

        if (start && ticketDate.isBefore(start, "day")) {
          return false;
        }

        if (end && ticketDate.isAfter(end, "day")) {
          return false;
        }

        return true;
      });
    },
    getBoleto(row) {
      const https = require("https");
      const userEmail = row.user_email || row.email || "";
      var qData = {
        firebase_ticket_id: row.id,
        firebase_ticket_uid: row.id,
        user_id: row.user_id,
        firebase_user_uid: row.user_id,
        email: userEmail,
        user_email: userEmail,
        source: "reportes_informe_row",
        cadena: row.cadena,
        sucursal: row.sucursal,
        vendedor: row.vendedor,
        producto: row.producto,
        peso: row.peso,
      };
      return this.$http
        .post(
          process.env.VUE_APP_API_URL + "getBo.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("bo RESPONSE");
            console.log(response);

            let res = response.body;
            // console.log({ res });
            //alert(res.boleto);
            if (res.status === "ok") {
              this.boleto = res.boleto;
              await this.$store.dispatch("changeStatusTicketValidacion", {
                status: row.status,
                ticket_id: row.id,
                user_id: row.user_id,
                boleto: this.boleto,
              });
              this.refrescaTickets(row);
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            swal.fire(
              "Oops",
              "Hubo un error al momento de validar el ticket, por favor intenta de nuevo.",
              "warning"
            );
            this.$store.dispatch("showLoader", false);
          }
        );
    },
    async getTicketById(ticketId) {
      console.log("Getting ticket with ID:", ticketId);

      try {
        const doc = await ticketsCollection.doc(ticketId).get();

        if (doc.exists) {
          const ticket = doc.data();
          ticket.id = doc.id; // opcional, si quieres incluir el ID
          this.ticetk = ticket; // si quieres que sea un array
        } else {
          console.log("No ticket found with that ID");
          this.tickets = [];
        }
      } catch (error) {
        console.error("Error getting ticket:", error);
      }
    },
    async getTickets() {
      console.log("getting tickets");
      //const docs = await ticketsCollection.where("status","==","por validar").get();
      const docs = await ticketsCollection.get();

      //await this.getAhora();

      this.tickets = [];
      this.allTickets = [];
      docs.forEach((doc) => {
        let ticket = doc.data();
        //console.log(ticket.user_id );

        //if (ticket.user_id == "Vu7dm3jyJlNFCiVJdLov9ze2PeI2") return;

        ticket.id = doc.id;

        try {
          ticket.nombre = this.users[ticket.user_id].nombre;
        } catch (err) {
          ticket.nombre = "";
        }
        try {
          ticket.apellido = this.users[ticket.user_id].apellido;
        } catch (err) {
          ticket.apellido = "";
        }
        try {
          ticket.user_email = ticket.user_email || "";
          ticket.email = this.users[ticket.user_id].email || ticket.user_email;
        } catch (err) {
          ticket.email = ticket.user_email || "";
        }
        try {
          ticket.celular = this.users[ticket.user_id].celular;
        } catch (err) {
          ticket.celular = "";
        }
        try {
          ticket.fecha_nacimiento = moment(
            this.users[ticket.user_id].fecha_nacimiento
          ).format("DD/MM/YYYY");
        } catch (err) {
          ticket.fecha_nacimiento = "";
        }

        let mnms2 = "NO";
        try {
          if (ticket.mnms != undefined && ticket.mnms == true) {
            mnms2 = "SI";
          }
        } catch (err) {
          //ticket.monto = 0;
        }
        ticket.mnms = mnms2;

        if (ticket.puntos == undefined || ticket.puntos == null) {
          ticket.puntos = 0;
        }

        try {
          ticket.tiempo = this.secondsToHms(ticket.time);
        } catch (err) {
          //console.log({ errortime: err });
          //console.log({errortimesuser: ticket.user.id});
        }

        try {
          ticket.week = parseInt(ticket.week) - 15;
        } catch (err) {
          //console.log({ errortime: err });
          //console.log({errortimesuser: ticket.user.id});
        }

        ticket.segundos = ticket.time;

        try {
          //delete ticket.substatus;
        } catch (err) {
          //err
        }
        try {
          delete ticket.respuestas;
        } catch (err) {
          //err
        }
        // try{
        //   delete ticket.retos;
        // }catch(err){
        //   //err
        // }
        try {
          delete ticket.beneficios;
        } catch (err) {
          //err
        }
        try {
          delete ticket.participaciones;
        } catch (err) {
          //err
        }

        //ticket.puntos_convertidos = ticket.puntos_totales;

        // try {
        //   ticket.week = this.getNumSemana(
        //     this.getFechaFormato(ticket.created_on_server.seconds)
        //   );
        // } catch (err) {
        //   console.log({ weekerror: err });
        //   ticket.week = -1;
        // }

        // // // try {
        // // //   ticket.monto.toString();
        // // // } catch (err) {
        // // //   ticket.monto = 0;
        // // // }

        // // // try {
        // // //   if(ticket.cashi === true){
        // // //     ticket.cashi = 'Pago con CASHI';
        // // //   }
        // // // } catch (err) {
        // // //   ticket.cashi = '';
        // // // }

        // // // if(ticket.substatus == undefined || ticket.substatus == null){
        // // //   ticket.substatus = '';
        // // // }

        if (
          ticket.ticket_ocr != undefined ||
          ticket.ticket_ocr != null ||
          ticket.ticket_ocr != ""
        ) {
          try {
            ticket.total_ticket = ticket.ticket_ocr.total;
          } catch (e) {
            ticket.total_ticket = "";
          }
          try {
            ticket.fecha_ticket = ticket.ticket_ocr.date;
          } catch (e) {
            ticket.fecha_ticket = "";
          }
          try {
            ticket.cadena_ticket = ticket.ticket_ocr.vendor.raw_name;
          } catch (e) {
            ticket.cadena_ticket = "";
          }
        }

        // try {
        //   ticket.score = this.sumaScore(ticket.participaciones, ticket.cashi);
        // } catch (err) {
        //   //
        //   ticket.score = 0;
        // }

        // try {
        //   ticket.retos = "";
        // } catch (err) {
        //   //
        // }

        //this.sumaStatsUser(ticket.user_id, ticket.puntos, ticket.time);

        // try {
        //   ticket.intento_trampa = moment
        //     .unix(ticket.intento_trampa.seconds)
        //     .format("DD/MM/YYYY HH:mm:ss");
        // } catch (err) {
        //   ticket.intento_trampa = "";
        // }

        // ticket.diferencia_segundos_user = this.calculaDiferenciaTiempos(
        //   ticket.started_on,
        //   ticket.finished_on
        // );
        // console.log(ticket.diferencia_segundos_user);
        try {
          ticket.started_on = moment
            .unix(ticket.started_on.seconds)
            .format("DD/MM/YYYY HH:mm:ss");
        } catch (err) {
          ticket.started_on = "";
        }
        // try {
        //   ticket.finished_on = moment
        //     .unix(ticket.finished_on.seconds)
        //     .format("DD/MM/YYYY HH:mm:ss");
        // } catch (err) {
        //   ticket.finished_on = "";
        // }

        const createdOnServer = ticket.created_on_server || ticket.created_on;
        let createdOnServerMoment = null;

        try {
          createdOnServerMoment = moment.unix(createdOnServer.seconds);
          ticket.created_on_server_filter =
            createdOnServerMoment.format("YYYY-MM-DD");
        } catch (err) {
          ticket.created_on_server_filter = "";
        }

        // try {
        //   ticket.diferencia_segundos_servidor = this.calculaDiferenciaTiempos(
        //     createdOnServer,
        //     ticket.finished_on_server
        //   );
        // } catch (e) {
        //   ticket.diferencia_segundos_servidor = "";
        // }

        try {
          ticket.created_on_server = createdOnServerMoment.format(
            "DD/MM/YYYY HH:mm:ss"
          );
        } catch (err) {
          ticket.created_on_server = "";
        }
        try {
          ticket.finished_on_server = moment
            .unix(ticket.finished_on_server.seconds)
            .format("DD/MM/YYYY HH:mm:ss");
        } catch (err) {
          ticket.finished_on_server = "";
        }

        this.allTickets.push(ticket);
      });
      this.allTickets = this.allTickets.sort(this.custom_sort);
      this.setLastSevenDaysFilter(false);
      this.applyDateFilter();
      //console.log({ tickets: this.tickets });

      //this.setUsersArray();
      this.$store.dispatch("showLoader", false);
    },
    setUsersArray() {
      this.users_array = [];
      Object.keys(this.users).forEach((key) => {
        let obj = this.users[key];
        obj.user_id = key;
        obj.edad = moment().diff(obj.fecha_nacimiento, "years");
        //console.log(key, obj);
        this.users_array.push(obj);
      });
    },
    sumaScore(participaciones, cashi) {
      let score = 0;
      participaciones.forEach((participacion) => {
        score += participacion.score;
      });

      if (cashi === "Pago con CASHI") {
        score = score * 2;
      }

      return score;
    },
    sumaStatsUser(user_id, puntos, time) {
      if (puntos == undefined) puntos = 0;
      if (time == undefined) time = 0;

      let multiplicador = 1;

      // console.log(user_id);
      // console.log(this.users[user_id]);

      if (this.users[user_id] == undefined) return;

      if (this.users[user_id].suma_puntos == undefined)
        this.users[user_id].suma_puntos = 0;
      try {
        this.users[user_id].suma_puntos += parseInt(puntos) * multiplicador;
      } catch (err) {
        console.log(err);
      }

      if (this.users[user_id].suma_time == undefined)
        this.users[user_id].suma_time = 0;
      try {
        this.users[user_id].suma_time += parseInt(time);
        this.users[user_id].suma_time_txt = this.secondsToHms(
          this.users[user_id].suma_time
        );
      } catch (err) {
        console.log(err);
      }

      if (this.users[user_id].num_tickets == undefined)
        this.users[user_id].num_tickets = 0;
      try {
        this.users[user_id].num_tickets++;
      } catch (err) {
        console.log(err);
      }
    },
    calculaDiferenciaTiempos(started, finished) {
      try {
        //console.log({ started: started.seconds });
        //console.log({ finished: finished.seconds });
        if (started.seconds == null || finished.seconds == null) return "error";
        let d1 = moment.unix(started.seconds);
        //console.log({ d1: d1 });
        let d2 = moment.unix(finished.seconds);
        //console.log({ d2: d2 });
        return d2.diff(d1, "seconds");
      } catch (err) {
        return "error";
      }
    },
    async getUsers() {
      console.log("getting users");
      //const docs = await usersCollection.limit(100).get();
      const docs = await usersCollection.get();
      //console.log({ userDocs: docs });
      this.users = {};
      docs.forEach((doc) => {
        let user = doc.data();
        //user.id = doc.id;
        //console.log(doc.id)

        try {
          if (user.created_on.seconds != undefined) {
            console.log("encontro fecha nueva");
            user.created_on = moment
              .unix(user.created_on.seconds)
              .format("ddd, DD MMM YYYY HH:mm:ss");

            user.dia_registro = moment(user.created_on).format("DD MMM");
          } else {
            user.dia_registro = moment(user.created_on).format("DD MMM");
          }
        } catch (err) {
          console.log({ fecha_error: err });
        }

        try {
          delete user.no_cupones_validos_oxxo;
        } catch (err) {
          //err
        }
        try {
          delete user.no_cupones_validos_dulceria;
        } catch (err) {
          //err
        }
        try {
          delete user.no_cupones_juego;
        } catch (err) {
          //err
        }
        try {
          delete user.no_cupones_registro;
        } catch (err) {
          //err
        }

        //console.log({ fecha: user.dia_registro });

        this.users[doc.id] = user;
      });
      console.log({ users: this.users });
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    // procesaTickets(){
    //   this.tickets_procesados = []
    //   this.tickets.forEach(ticket => {

    //   })
    // },
    custom_sort(a, b) {
      return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
    },
    getNumSemana(fecha) {
      return parseInt(this.getSemana(fecha)) - SEMANA_INICIAL;
    },
    getSemana(fecha) {
      return moment(fecha).add(2, "days").week();
    },
    getFechaFormato(time) {
      return moment.unix(time).format("MMM D, Y HH:mm:ss");
    },
    async getAhora() {
      this.$store.dispatch("showLoader", true);
      var thes = this;
      //fb.functions.useFunctionsEmulator('http://localhost:5000')
      var getFecha = fb.functions.httpsCallable("getAhora");

      let res = null;
      await getFecha("{}")
        .then(function (result) {
          // Read result of the Cloud Function.
          console.log({ resultadoGetAhora: result });
          thes.ahora = thes.getFechaFormato(result.data._seconds);
          //console.log({ahora: thes.ahora})
        })
        .catch(function (error) {
          console.log({ errorgetahora: error });
        });

      this.$store.dispatch("showLoader", false);
    },
    async changeStatusTicket(row, id, userId, value, email) {
      console.log({ changeStatus: id });
      console.log({ changeStatus: value });
      console.log({ changeStatus: email });

      this.$store.dispatch("showLoader", true);

      try {
        if (value == "valido") {
          await this.getBoleto(row);
        } else {
          this.boleto = "invalido";
          await this.$store.dispatch("changeStatusTicketValidacion", {
            status: value,
            ticket_id: id,
            user_id: userId,
            boleto: this.boleto,
          });
        }

        swal.fire("Bien", "Se ha actualizado el estatus del ticket.", "success");

        //this.getTickets();

        this.refrescaTickets(row);
      } catch (error) {
        console.log({ changeStatusTicketError: error });
        swal.fire(
          "Oops",
          "No se pudo actualizar el estatus del ticket, por favor intenta de nuevo.",
          "warning"
        );
      } finally {
        this.$store.dispatch("showLoader", false);
      }
    },
    refrescaTickets(row) {
      for (var i = 0; i < this.tickets.length; i++) {
        if (this.tickets[i].id === row.id) {
          this.tickets[i].status = row.status;
          this.tickets[i].boleto = this.boleto;
        }
      }
    },
    getTicketFieldKey(row, field) {
      return `${row.id}_${field}`;
    },
    rememberTicketFieldValue(row, field) {
      if (!row || !row.id || !field) {
        return;
      }

      this.editingOriginalValues[this.getTicketFieldKey(row, field)] =
        row[field] === undefined || row[field] === null ? "" : row[field];
    },
    getTicketFieldLabel(field) {
      const labels = {
        cadena: "Cadena",
        sucursal: "Sucursal",
        vendedor: "Vendedor",
        producto: "Producto",
        peso: "Peso",
        cantidad: "Cantidad",
      };

      return labels[field] || field;
    },
    async updateTicketField(row, field) {
      if (!row || !row.id || !field) {
        return;
      }

      const key = this.getTicketFieldKey(row, field);
      const previousValue =
        this.editingOriginalValues[key] !== undefined
          ? this.editingOriginalValues[key]
          : "";
      const newValue =
        row[field] === undefined || row[field] === null ? "" : row[field];

      if (`${previousValue}` === `${newValue}`) {
        return;
      }

      const confirmation = await swal.fire({
        title: "Confirmar ajuste",
        html: `Estás por actualizar <b>${this.getTicketFieldLabel(
          field
        )}</b> a:<br><br><b>${newValue || "Sin valor"}</b>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, guardar",
        cancelButtonText: "Cancelar",
      });

      if (!confirmation.value && !confirmation.isConfirmed) {
        row[field] = previousValue;
        this.syncTicketField(row.id, field, previousValue);
        return;
      }

      try {
        this.$store.dispatch("showLoader", true);

        const data = {
          [field]: newValue,
          reporte_updated_at: new Date(),
        };

        await ticketsCollection.doc(row.id).update(data);

        this.syncTicketField(row.id, field, data[field]);

        swal.fire("Bien", "Se ha actualizado el ticket.", "success");
        delete this.editingOriginalValues[key];
      } catch (error) {
        console.log({ updateTicketFieldError: error });
        row[field] = previousValue;
        this.syncTicketField(row.id, field, previousValue);
        swal.fire(
          "Oops",
          "No se pudo actualizar el ticket, por favor intenta de nuevo.",
          "warning"
        );
      } finally {
        this.$store.dispatch("showLoader", false);
      }
    },
    syncTicketField(ticketId, field, value) {
      for (var i = 0; i < this.tickets.length; i++) {
        if (this.tickets[i].id === ticketId) {
          this.tickets[i][field] = value;
        }
      }

      for (var j = 0; j < this.allTickets.length; j++) {
        if (this.allTickets[j].id === ticketId) {
          this.allTickets[j][field] = value;
        }
      }
    },
    async changeSubStatusTicket(id, userId, value, email) {
      console.log({ changeSubtatus: id });
      console.log({ changeSubtatus: value });
      console.log({ changeSubtatus: email });

      this.$store.dispatch("showLoader", true);

      await this.$store.dispatch("changeSubStatusTicketValidacion", {
        status: value,
        ticket_id: id,
        user_id: userId,
      });

      swal.fire(
        "Bien",
        "Se ha actualizado el subestatus del ticket.",
        "success"
      );

      //this.getTickets();

      for (var i = 0; i < this.tickets.length; i++) {
        if (this.tickets[i].id === id) {
          this.tickets[i].substatus = value;
        }
      }
    },

    async changeStatusMembresia(id, userId, value, email) {
      console.log({ changeStatus: id });
      console.log({ changeStatus: value });
      console.log({ changeStatus: email });

      this.$store.dispatch("showLoader", true);

      await this.$store.dispatch("changeStatusMembresiaValidacion", {
        status: value,
        ticket_id: id,
        user_id: userId,
      });

      swal.fire(
        "Bien",
        "Se ha actualizado el estatus de la membresía.",
        "success"
      );

      //this.getTickets();

      for (var i = 0; i < this.tickets.length; i++) {
        if (this.tickets[i].id === id) {
          this.tickets[i].status_membresia = value;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.report-cell-select {
  min-width: 230px;
  height: 34px;
  padding: 4px 8px;
  font-size: 13px;
}

.report-cell-input {
  height: 34px;
  padding: 4px 8px;
  font-size: 13px;
}

.report-cell-input-wide {
  min-width: 260px;
}

.report-cell-input-small,
.report-cell-select-small {
  min-width: 110px;
}

.report-date-filter {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;

  label {
    display: flex;
    flex-direction: column;
    min-width: 180px;
    margin: 0;
    font-size: 13px;
    font-weight: bold;
    color: #21376f;
  }

  input {
    height: 38px;
    margin-top: 4px;
    padding: 6px 10px;
    border: 1px solid #ced4da;
    border-radius: 4px;
  }
}
</style>
